import React, { useState } from 'react'
import ModalChangePaymentAmount from './modalChangePaymentAmount'
import ModalTipSelection from './modalTipSelection'
import ModalChangeTips from './modalChangeTips'
import ModalProcessPaymentTap2Pay from './modalProcessPaymentTap2Pay'
import ModalSucceededPaymentTap2Pay from './modalSucceededPaymentTap2Pay'
import ModalTap2PayAvailabilityChecker from './modalTap2PayAvailabilityChecker'

const Tap2PayModals = React.memo(({
	totalPrice, closeChangePaymentAmountModal, handlePayment, printReceipt = false, module,
	orderType, resetCart, paymentSource, showTap2PayAvailabilityCheckerModal, setShowTap2PayAvailabilityCheckerModal, setShowChangePaymentAmountModal, showChangePaymentAmountModal,
}) => {
	const [showTipSelectionModal, setShowTipSelectionModal] = useState(false)
	const [showChangeTipsModal, setShowChangeTipsModal] = useState(false)
	const [showProcessPaymentTap2PayModal, setShowProcessPaymentTap2PayModal] = useState(false)
	const [showSucceededPaymentTap2PayModal, setShowSucceededPaymentTap2PayModal] = useState(false)

	return (
		<>
			<ModalTap2PayAvailabilityChecker isOpen={showTap2PayAvailabilityCheckerModal}
																			 setShowTap2PayAvailabilityCheckerModal={setShowTap2PayAvailabilityCheckerModal}
																			 setShowChangePaymentAmountModal={setShowChangePaymentAmountModal} />
			<ModalChangePaymentAmount totalPrice={totalPrice}
																isOpen={showChangePaymentAmountModal}
																close={closeChangePaymentAmountModal}
																setShowChangePaymentAmountModal={setShowChangePaymentAmountModal}
																setShowProcessPaymentTap2PayModal={setShowProcessPaymentTap2PayModal}
																setShowTipSelectionModal={setShowTipSelectionModal} />
			<ModalTipSelection isOpen={showTipSelectionModal}
												 totalPrice={totalPrice}
												 showTipSelectionModal={showTipSelectionModal}
												 setShowChangeTipsModal={setShowChangeTipsModal}
												 setShowProcessPaymentTap2PayModal={setShowProcessPaymentTap2PayModal}
												 setShowChangePaymentAmountModal={setShowChangePaymentAmountModal}
												 setShowTipSelectionModal={setShowTipSelectionModal} />
			<ModalChangeTips isOpen={showChangeTipsModal}
											 totalPrice={totalPrice}
											 setShowProcessPaymentTap2PayModal={setShowProcessPaymentTap2PayModal}
											 setShowTipSelectionModal={setShowTipSelectionModal}
											 setShowChangeTipsModal={setShowChangeTipsModal} />
			<ModalProcessPaymentTap2Pay isOpen={showProcessPaymentTap2PayModal}
																	totalPrice={totalPrice}
																	handlePayment={handlePayment}
																	paymentSource={paymentSource}
																	setShowProcessPaymentTap2PayModal={setShowProcessPaymentTap2PayModal}
																	setShowSucceededPaymentTap2PayModal={setShowSucceededPaymentTap2PayModal} />
			<ModalSucceededPaymentTap2Pay isOpen={showSucceededPaymentTap2PayModal}
																		totalPrice={totalPrice}
																		printReceipt={printReceipt}
																		module={module}
																		orderType={orderType}
																		resetCart={resetCart}
																		setShowSucceededPaymentTap2PayModal={setShowSucceededPaymentTap2PayModal}/>
		</>

	)
})

Tap2PayModals.displayName = 'Tap2PayModals'
export default Tap2PayModals
